import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';

import { TranslationModule } from 'core/translation/translation.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { GalleryComponent } from './gallery.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ImageSelectionDirectiveModule,
    MatModule,
    NgxPaginationModule,
    TranslationModule,
    PipesModule,
  ],
  declarations: [
    GalleryComponent,
  ],
  exports: [
    GalleryComponent,
  ],
})
export class GalleryModule { }
